import React from 'react';

export default class CustomizedLabel extends React.Component {
    render() {
        const { x, y, fill, value, width } = this.props;
        return (
            <text
                x={x + width / 2}
                y={y}
                dy={-4}
                fontSize='16'
                fontFamily='sans-serif'
                fill={fill}
                textAnchor="middle">{value}</text>
        )
    }
}